import React from 'react';
import c from 'classnames';

import { CheckboxFill, CircleOutline } from '@lyearn/icons';

import { checkBoxStyles, circularCheckBoxFocusStyles } from './utils/styles';
import BaseCheckbox from './BaseCheckbox';
import { CheckboxProps } from './types';
import { CHECK_SIZE_CLASSES } from './utils';

const CircularCheckbox = React.forwardRef<HTMLButtonElement, CheckboxProps>((props, ref) => {
  const { className, size = 'medium', ...rest } = props;
  const sizeClasses = CHECK_SIZE_CLASSES[size];

  return (
    <BaseCheckbox
      ref={ref}
      disableRipple
      checkedIcon={<CheckboxFill className={c('rounded-full', sizeClasses)} />}
      className={c('p-0', className, checkBoxStyles, circularCheckBoxFocusStyles)}
      icon={<CircleOutline className={sizeClasses} />}
      {...rest}
    />
  );
});

export default React.memo(CircularCheckbox);
